export function foldersWereDropped(dataTransfer: DataTransfer): boolean {
    const items = dataTransfer.items;
    const files = dataTransfer.files;

    if (items) {
        const count = items.length;
        for (let i = 0; i < count; i++) {
            if (dataTransferItemIsFolder(items[i])) {
                return true;
            }
        }
    } else {
        // IE does not have an items collection on drag events,
        // and will return a zero-length files collection if
        // a folder was dropped.
        if (files.length === 0) {
            return true;
        }
    }

    return false;
}

export function getFileArrayFromDragDataTransfer(dataTransfer: DataTransfer): File[] {
    const items = dataTransfer.items;
    const files = dataTransfer.files;

    // IE will not have an items collection on drag events.
    return items ? getFileArrayFromDataTransferItemList(items) : getFileArrayFromFileList(files);
}

export function getFileArrayFromFileList(items: FileList): File[] {
    const output = new Array<File>();
    const count = items.length;
    for (let i = 0; i < count; i++) {
        output.push(items[i]);
    }

    return output;
}

function getFileArrayFromDataTransferItemList(items: DataTransferItemList): File[] {
    const output = new Array<File>();
    const count = items.length;
    for (let i = 0; i < count; i++) {
        const item = items[i];
        if (!dataTransferItemIsFolder(item)) {
            output.push(item.getAsFile());
        }
    }

    return output;
}

function dataTransferItemIsFolder(item: DataTransferItem): boolean {
    if (item.webkitGetAsEntry) {
        const entryItem = item.webkitGetAsEntry();
        return entryItem.isDirectory;
    }

    return false;
}
